import React from 'react'

import Text from 'components/common/Text'
import theme from 'theme'

export interface LegendItem {
  label?: string
  link?: React.ReactNode
  text?: string
  color?: string
}

type TargetGraphLegendProps = {
  items: LegendItem[]
}

const TargetGraphLegend: React.FC<TargetGraphLegendProps> = React.memo(
  ({ items, ...rest }) => {
    return (
      <ul
        css={{
          listStyle: 'none',
          margin: 0,
          padding: theme.space[3],
          width: '100%',
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(96px, 1fr))',
          columnGap: theme.space[3],
          rowGap: theme.space[1],
          textAlign: 'left'
        }}
        {...rest}
      >
        {items.map(({ label, link, text, color }) => {
          return (
            <li
              key={label}
              css={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr',
                gap: theme.space[2],
                alignItems: 'center'
              }}
            >
              <div
                css={{
                  width: theme.space[3],
                  height: theme.space[3],
                  borderRadius: theme.borderRadius[2],
                  backgroundColor: color,
                  border: `1px solid ${theme.colors.border[0]}` // help lighter legend colors (e.g., container) stand out more
                }}
              />
              <div
                css={{
                  display: 'grid',
                  gridTemplateColumns: `${theme.space[7]}px 1fr`,
                  alignItems: 'center',
                  gap: theme.space[5]
                }}
              >
                <Text
                  as="h6"
                  css={{
                    textTransform: 'capitalize',
                    color: theme.colors.steel[2],
                    whiteSpace: 'nowrap'
                  }}
                >
                  {link ?? label}
                </Text>
                {text && (
                  <Text
                    css={{
                      fontSize: theme.fontSizes[0],
                      color: theme.colors.steel[1]
                    }}
                  >
                    {text}
                  </Text>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    )
  }
)

export default TargetGraphLegend
